const authRootUrl = 'https://auth.serenefire.com';

export const firebaseWebSDKConfig = {
    apiKey: "AIzaSyBNesO-fuWKhJOVBTAh--lMPZm3hkpKfDg",
    authDomain: "ares-7b845.firebaseapp.com",
    databaseURL: "https://ares-7b845.firebaseio.com",
    projectId: "ares-7b845",
    storageBucket: "ares-7b845.appspot.com",
    messagingSenderId: "297687985531",
    appId: "1:297687985531:web:850a53a1ca66867ed961de",
    measurementId: "G-FL7XDRBMGP"
};

export const reCaptchaSiteKey = '6LdpDJEhAAAAAN5FhKh5aj_DTvMED5iM6YIhBiS2';
export const signUpUrl = `${authRootUrl}/signup.json`;
export const signInUrl = `${authRootUrl}/signin.json`;
export const adminAppName = 'ares-production';
export const clientProductCode = 'neofelis';
